class ContactForm {
    checkField( node = null /* form field */ ) { 
        let t = this;
        let input = null;

        if( !node.hasAttribute('data-field') ) {
            return;
        }
        switch( node.getAttribute('data-field') ) {

            case 'tel' :
            case 'text' :
            case 'email' :
                    input = node.querySelector('input[type="'+node.getAttribute('data-field')+'"]');
                    if( input.hasAttribute('aria-required') && !input.value.trim() ) {
                        input.setAttribute('aria-invalid', 'true');
                    } else {
                        input.removeAttribute('aria-invalid');
                    }

                    if( input.value && node.getAttribute('data-field') == 'email' ) {
                        if( !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test( input.value ) ) {
                            input.setAttribute('aria-invalid', 'true');
                        } else {
                            input.removeAttribute('aria-invalid');
                        }
                    }

                break;
            case 'name' :
                    input = node.querySelector('input[type="text"]');
                    if( input.hasAttribute('aria-required') && !input.value.trim() ) {
                        input.setAttribute('aria-invalid', 'true');
                    } else {
                        input.removeAttribute('aria-invalid');
                    }
                break;
            case 'textarea' :
                    input = node.querySelector('textarea');
                    if( input.hasAttribute('aria-required') && !input.value.trim() ) {
                        input.setAttribute('aria-invalid', 'true');
                    } else {
                        input.removeAttribute('aria-invalid');
                    }
                break;
            case 'terms' :
                    node.querySelectorAll('input[type="checkbox"]').forEach( ( input, index ) => {
                        if( !input.checked ) {
                            input.setAttribute('aria-invalid', 'true');
                        } else {
                            input.removeAttribute('aria-invalid');
                        }
                    });
                break;
            case 'select' :
                    input = node.querySelector('select');
                    if( input.hasAttribute('aria-required') && !input.value ) {
                        input.setAttribute('aria-invalid', true);
                    } else {
                        input.removeAttribute('aria-invalid');
                    }
                break;
            case 'radio' :
                    input = node.querySelector('fieldset');
                    if( input.hasAttribute('aria-required') && !input.querySelector('input[type="radio"]:checked') ) {
                        node.classList.add('FieldRadio--invalid');
                        input.setAttribute( 'aria-invalid', 'true' );
                    } else {
                        node.classList.remove('FieldRadio--invalid');
                        input.removeAttribute( 'aria-invalid' );
                    }
                break;
            case 'checkbox' :
                    input = node.querySelector('fieldset');
                    if( input.hasAttribute('aria-required') && !input.querySelector('input[type="checkbox"]:checked') ) {
                        node.classList.add('FieldCheckbox--invalid');
                        input.setAttribute( 'aria-invalid', 'true' );
                    } else {
                        node.classList.remove('FieldCheckbox--invalid');
                        input.removeAttribute( 'aria-invalid' );
                    }
                break;
            
            case 'score' :
                    input = node.querySelectorAll('.row__button.active');
                    if( input.length > 0 ) {
                        node.classList.remove('FieldScore--invalid');
                    } else {
                        node.classList.add('FieldScore--invalid');
                    }
                break;

        }
    }
    resetField( node = null /* form field */ ) {
        let t = this;

        if( !node.hasAttribute('data-field') ) {
            return;
        }
        switch( node.getAttribute('data-field') ) {

            case 'tel' :
            case 'text' :
            case 'email' :
                    node.querySelector('input[type="'+node.getAttribute('data-field')+'"]').value = null;
                break;
            case 'name' :
                    node.querySelector('input[type="text"]').value = null;
                break;
            case 'textarea' :
                    node.querySelector('textarea').value = null;
                break;
            case 'terms' :
            case 'checkbox':
            case 'salesmanago' : 
                    node.querySelectorAll('input[type="checkbox"]').forEach( ( input, index ) => {
                        input.checked = false;
                    });
                break;
            case 'radio' :
                    node.querySelectorAll('input[type="radio"]').forEach( ( input, index ) => {
                        input.checked = false;
                    });
                break;
            case 'score' :
                    node.querySelectorAll('.row__button').forEach( ( el, index ) => {
                        if( index < 3 ) {
                            el.classList.add('active');
                        } else {
                            el.classList.remove('active');
                        }
                    });
                break;

        }
    }
    getData( node = null /* form field */ ) {
        let t = this;
        let input = null;
        let arr = [];
        let response = {};

        if( !node.hasAttribute('data-field') ) {
            return;
        }
        response.type = node.getAttribute('data-field');
        switch( node.getAttribute('data-field') ) {

            case 'tel' :
            case 'text' :
            case 'email' :
                    input = node.querySelector('input[type="'+node.getAttribute('data-field')+'"]');
                    response.label = input.getAttribute('data-label');
                    response.value = input.value;
                    response.name = input.name;
                break;

            case 'name' :
                    input = node.querySelector('input[type="text"]');
                    response.label = input.getAttribute('data-label');
                    response.value = input.value;
                    response.name = input.name;
                break;

            case 'textarea' :
                    input = node.querySelector('textarea');
                    response.label = input.getAttribute('data-label');
                    response.value = input.value;
                    response.name = input.name;
                break;

            case 'terms' :
                    response.terms = [];
                    node.querySelectorAll('input[type="checkbox"]:checked').forEach( ( input, index ) => {
                        response.terms.push( input.getAttribute('data-label') );
                    });
                break;

            case 'salesmanago' : 
                    if( node.querySelector('input[type="checkbox"]:checked') ) {
                        response.value = 'true';
                    } else {
                        response.value = 'false';
                    }
                    response.name = 'SalesManago';
                break;
            case 'select' :
                    response.label = node.querySelector('select').getAttribute('data-label');
                    response.value = node.querySelectorAll('select option')[ node.querySelector('select').selectedIndex ].getAttribute('data-label');
                    response.name = node.querySelector('select').getAttribute('name'); 
                break;
            
            case 'checkbox' :
                    response.label = node.querySelector('fieldset').getAttribute('data-label');
                    node.querySelectorAll('input[type="checkbox"]:checked').forEach( ( input, index ) => {
                        arr.push( input.getAttribute('data-value') );
                    });
                    response.value = arr.join(', ');
                    response.name = node.querySelector('input[type="checkbox"]').name;
                break;
            case 'radio' :
                    response.label = node.querySelector('fieldset').getAttribute('data-label');
                    node.querySelectorAll('input[type="radio"]:checked').forEach( ( input, index ) => {
                        arr.push( input.getAttribute('data-value') );
                    });
                    response.value = arr.join(', ');
                    response.name = node.querySelector('input[type="radio"]').name;
                break;
            case 'score' :
                    response.label = node.getAttribute('data-label');
                    response.value = parseInt( node.querySelectorAll('.row__button.active')[ node.querySelectorAll('.row__button.active').length - 1 ].getAttribute('data-score') );
                    response.name = 'score';
                break;

        }
        return response;

    }
}
export default ContactForm;